import { createMutation } from "@evergis/react-fetching";
import { BatchResourcesAclDc } from "@evergis/api/dist/__generated__/data-contracts";

import { api as evergisApi } from "../evergis/api";

export const updatePermissions = createMutation(
  (data: BatchResourcesAclDc) => async api => ({
    data: await api.bulk.batchResourcesPermissionsSet(data),
  }),
  {
    injected: evergisApi,
  },
);
